module.exports = __webpack_public_path__ + "img/yz_4@2x.55b0e142.png";